import { render, staticRenderFns } from "./footMenu.vue?vue&type=template&id=720d3616&scoped=true"
import script from "./footMenu.vue?vue&type=script&lang=js"
export * from "./footMenu.vue?vue&type=script&lang=js"
import style0 from "./footMenu.vue?vue&type=style&index=0&id=720d3616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d3616",
  null
  
)

export default component.exports